class SeeTheSet extends HTMLElement {

  constructor() {
    super();
    this.learnClubButtons = this.querySelectorAll('[data-learn-clubs]');
    this.learnClubButtons.forEach(tab => tab.addEventListener('click', this.onClickHandler.bind(this)));
  }

  onClickHandler(event) {
    this.querySelector('[data-learn-clubs].active').setAttribute('aria-selected', 'false');
    this.querySelector('[data-learn-clubs].active').classList.remove('active');
    this.querySelector('[data-learn-club-info].active')?.classList.remove('active');
    event.target.classList.add('active');
    event.target.setAttribute('aria-selected', 'true');
    const learnTab = event.target.dataset.learnClubs;
    this.querySelector(`[data-learn-club-info="${learnTab}"]`)?.classList.add('active');
  }

}
customElements.define('see-the-set', SeeTheSet);